import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "VaSidebarItemContent"
});
export {
  _sfc_main as _
};

import '../../../../VaSidebarItemContent.css';
//# sourceMappingURL=VaSidebarItemContent.vue_vue_type_script_lang-633f084d.mjs.map
